var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.26 12.5C8.60422 12.5 7.25 13.8542 7.25 15.51V22.24C7.25 23.8958 8.60422 25.25 10.26 25.25H21.74C23.3958 25.25 24.75 23.8958 24.75 22.24V21.8H23.6C22.1905 21.8 20.8223 20.7693 20.693 19.2467C20.6122 18.3845 20.9405 17.579 21.5093 17.02C22.0209 16.4981 22.7224 16.2 23.48 16.2H24.75V15.51C24.75 13.8542 23.3958 12.5 21.74 12.5H10.26ZM5.75 15.51C5.75 13.0258 7.77578 11 10.26 11H21.74C24.2242 11 26.25 13.0258 26.25 15.51V16.95C26.25 17.3642 25.9142 17.7 25.5 17.7H23.48C23.1209 17.7 22.8052 17.8392 22.5774 18.0732L22.5639 18.0867C22.2978 18.3464 22.1492 18.7162 22.1866 19.1089L22.1875 19.1177C22.2404 19.7527 22.8509 20.3 23.6 20.3H25.5C25.9142 20.3 26.25 20.6358 26.25 21.05V22.24C26.25 24.7242 24.2242 26.75 21.74 26.75H10.26C7.77578 26.75 5.75 24.7242 5.75 22.24V15.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1 7.94903C18.1 7.14151 17.293 6.58712 16.5458 6.87031L8.60542 9.87047C7.78865 10.1797 7.25 10.9595 7.25 11.839V16.409C7.25 16.8232 6.91421 17.159 6.5 17.159C6.08579 17.159 5.75 16.8232 5.75 16.409V11.839C5.75 10.3387 6.67154 8.99842 8.07458 8.46754L16.0142 5.46769C16.0143 5.46763 16.014 5.46774 16.0142 5.46769C17.7469 4.81126 19.6 6.09671 19.6 7.94903V11.749C19.6 12.1632 19.2642 12.499 18.85 12.499C18.4358 12.499 18.1 12.1632 18.1 11.749V7.94903Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4788 17.6992C23.1197 17.6992 22.804 17.8384 22.5761 18.0724L22.5627 18.0859C22.2966 18.3456 22.148 18.7154 22.1854 19.1081L22.1862 19.1169C22.2391 19.7519 22.8497 20.2992 23.5988 20.2992H25.5416C25.7032 20.2888 25.8088 20.1624 25.8088 20.0292V17.9692C25.8088 17.8361 25.7032 17.7096 25.5416 17.6992H23.4788ZM21.5081 17.0192C22.0197 16.4974 22.7211 16.1992 23.4788 16.1992H25.5588C25.5677 16.1992 25.5766 16.1994 25.5856 16.1997C26.5385 16.2337 27.3088 17.0049 27.3088 17.9692V20.0292C27.3088 20.9935 26.5385 21.7647 25.5856 21.7987C25.5766 21.799 25.5677 21.7992 25.5588 21.7992H23.5988C22.1893 21.7992 20.8211 20.7685 20.6917 19.2459C20.611 18.3837 20.9393 17.5782 21.5081 17.0192Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 16C10.25 15.5858 10.5858 15.25 11 15.25H18C18.4142 15.25 18.75 15.5858 18.75 16C18.75 16.4142 18.4142 16.75 18 16.75H11C10.5858 16.75 10.25 16.4142 10.25 16Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.4ede3fe3.svg";
export { ForwardRef as ReactComponent };